import { memo } from 'react';
import styled from '@emotion/styled';
import { mediaMax, zIndex } from 'presentations/views/styles';
import { white } from 'presentations/views/styles/color';
import {
  AllDayTimeGridView,
  CalendarView,
  WeekdayHeaderView,
} from 'presentations/views/components/atoms/Calendar';
import { useBookingCalendar } from './hooks';
import {
  EventListItem,
  MergeableEventListItem,
  Schedule,
} from '../../atoms/Calendar/reducer';
import DayTimeGridList from 'presentations/views/components/atoms/Calendar/DayTimeGridList';

export interface Props {
  onClickEvent: (event: MergeableEventListItem, element: HTMLElement) => void;
  onClickBookingSlot?: (event: EventListItem) => void;
  schedules: Schedule[] | null;
  isLoading?: boolean;
}

const Component = memo((props: Props) => {
  const { actions } = useBookingCalendar({
    schedules: props.schedules,
    isLoading: props.isLoading,
    onClickBookingSlot: props.onClickBookingSlot,
  });

  return (
    <DayTimeContainer>
      <Header>
        <WeekdayHeaderView />
        <AllDayTimeGridView onClickEvent={props.onClickEvent} />
      </Header>
      <DayTimeGridList
        onClickEvent={props.onClickEvent}
        onClickBookingSlot={actions.onClickBookingSlot}
        isLoading={props.isLoading}
      />
    </DayTimeContainer>
  );
});
const Header = styled.div`
  position: sticky;
  z-index: ${zIndex(1100)};
  top: 0;
  left: 0;
  background-color: ${white};
`;

const DayTimeContainer = styled(CalendarView)`
  background-color: ${white};
  width: 100%;
  height: inherit;
  ${mediaMax.tablet} {
    width: 100vw;
    min-width: 640px;
  }
`;
export default Component;
